import React from 'react';

import { useNavigate } from 'react-router-dom';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronButtonArea from '@/components/ui/box/JumbotronButtonArea.tsx';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription.tsx';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle.tsx';
import Button from '@/components/ui/buttons/Button';
import { pageTitles } from '@/constants/pageTitles';
import ParentsLimitExceededDescription from '@/features/invitations/components/ParentsLimitExceededDescription';
import { parentsLimitExceededError } from '@/features/invitations/constants';

import styles from './InviteLimitErrorPage.module.scss';

const InviteLimitErrorPage: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToMypage = () => {
    navigate('/mypage/profile');
  };

  return (
    <SingleColumnTemplate>
      <div className={styles.InviteLimitErrorPage}>
        <Jumbotron>
          <JumbotronPanel panelHeaderTitle={pageTitles.inviteEmailConfirm}>
            <JumbotronTitle>{parentsLimitExceededError.title}</JumbotronTitle>
            <JumbotronDescription>
              <ParentsLimitExceededDescription />
            </JumbotronDescription>
            <JumbotronButtonArea>
              <Button
                type="button"
                color="primary"
                size="m"
                onClick={handleNavigateToMypage}
              >
                マイページへ
              </Button>
            </JumbotronButtonArea>
          </JumbotronPanel>
        </Jumbotron>
      </div>
    </SingleColumnTemplate>
  );
};

export default InviteLimitErrorPage;
